export default "__VITE_ASSET__7dhGMrbF__"